module.exports = __webpack_public_path__ + "img/Group 633.70455505.png";